import React from "react";
import {
  Box,
  Button,
  Card,
  Grid,
  Modal,
  Stack,
  Typography
} from "@mui/material";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import Label from "src/components/Label";
import CustomLoader from "src/commonComponents/CustomLoader";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 900,
  bgcolor: "background.paper",
  boxShadow: 10,
  borderRadius: "10px",
  p: 2
};

const columns = [
  {
    name: "Member Name",
    selector: (row) => row?.m_name,
    sortable: true
  },
  {
    name: "Notification Read Date",
    selector: (row) => row?.r_date,
    sortable: true
  },
  {
    name: "Status",
    cell: (row) => (
      <Label variant="ghost" color="success" style={{ fontSize: "14px" }}>
        Read
      </Label>
    ),
    sortable: true
  }
];

const exportColumns = [
  { label: "Member Name", key: "m_name" },
  { label: "Notification Read Date", key: "r_date" }
];

function ReadNotificationModal({ open, onClose, data, isLoading }) {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Typography variant="h6" component="h2" style={{ marginBottom: "5px", textAlign: "center" }}>
          Notification Read By Members
        </Typography>
        <hr />
        <Stack style={{ marginBottom: "10px", marginTop: "10px" }}>
          <Grid container spacing={2} style={{ marginBottom: "10px" }}>
            <Grid item xs={10}></Grid>
            <Grid item xs={2}>
              <Button className="btn btn-export">
                <CSVLink
                  data={data}
                  headers={exportColumns}
                  filename="Notification Read Date.csv"
                  className="btn btn-primary test"
                  target="_blank"
                >
                  Export CSV
                </CSVLink>
              </Button>
            </Grid>
          </Grid>
          <Card>
            <DataTable
              filter
              fixedHeaderScrollHeight="450px"
              fixedHeader={true}
              pagination
              highlightOnHover
              columns={columns}
              data={data}
              progressPending={isLoading}
              progressComponent={<CustomLoader />}
            />
          </Card>
        </Stack>
        <hr />
        <div style={{ margin: "10px auto 0", display: "flex", justifyContent: "center" }}>
          <Button variant="outlined" onClick={onClose}>
            Close
          </Button>
        </div>
      </Box>
    </Modal>
  );
}

export default ReadNotificationModal;
